import { render, staticRenderFns } from "./Gestionepriorita.vue?vue&type=template&id=6f0dac26&"
import script from "./Gestionepriorita.vue?vue&type=script&lang=js&"
export * from "./Gestionepriorita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports